import React from 'react'
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core'
import { Paragraph, FlexContainer, PureSpinner } from 'heliocor-ui'
import 'styled-components/macro'

import { ImgBg } from '../../Carousel/Carousel'
import { ActionsWrapper } from '../Camera.elements'

const ImageSelfieActions = ({actions = [], loading}) => {
  const iconProps = {htmlColor: 'white', fontSize: 'large'}

  return (
    <ActionsWrapper>
      <FlexContainer justifyContent='center' alignItems='center'>
        {loading && <PureSpinner color='grey500'/>}
        {!loading && actions.map((action, index) =>
            <IconButton key={index} onClick={action.onClick}>
                {React.createElement(action.icon, iconProps)}
            </IconButton>
        )}
      </FlexContainer>
    </ActionsWrapper>
  )
}

const ImageSelfieMessage = ({message, width}) => {
  const { t } = useTranslation()
  return (
    <FlexContainer
      backgroundColor='main'
      width={width+'px'}
      padding='.45rem'
      justifyContent='center'
      css="text-align: center;"
    >
      <Paragraph color='white' margin='0 .25rem' value={t(message)} />
    </FlexContainer>
  )
}

const ImageSelfieViewer = ({imgDimensions, image}) => {
  return (
    <ImgBg 
      modal 
      noPadding
      src={image} 
      width={`${imgDimensions.width}px`} 
      height={`${imgDimensions.height}px`} 
   /> 
  )
 }

export { 
  ImageSelfieActions, 
  ImageSelfieMessage,
  ImageSelfieViewer
}